// Define the function
const toggleLinkList = () => {
  // Get the link list container
  const linkList = document.querySelector("[data-collection-link-list]");

  const initFlickity = () => {
    new Flickity(linkList, {
      cellSelector: "li",
      cellAlign: "center",
      contain: true,
      pageDots: false,
      adaptiveHeight: false,
      groupCells: true,
      prevNextButtons: false,
    });
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  initFlickity();
  window.addEventListener(
    "resize",
    debounce(() => {
      Flickity.data(linkList).destroy();
      initFlickity();
    }, 250)
  );
};

// Call the function
toggleLinkList();
